import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { WalletContext } from '@Components/Wallet/WalletContext'
import { manualVcBase } from './ManualVc.api'
export default function ManualVcWalletAction() {
	const { closeWallet } = useContext(WalletContext),
		{ t } = useTranslation('wallet')
	return (
		<Link style={{ color: 'inherit', display: 'block', margin: '12px 0' }} to={manualVcBase} onClick={() => closeWallet?.()}>
			{t('manual_vc.history')}
		</Link>
	)
}
